import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges, } from '@angular/core';

import { CandidateAdapter, SocialInfo, SocialInfoType } from '@shared/models';

const HTTP_PREFIX = 'http://';
const HTTPS_PREFIX = 'https://';

@Component({
  selector: 'mojo-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialLinksComponent implements OnInit, OnChanges {
  @Input() candidate: CandidateAdapter;
  @Input() mini = false;
  @Input() inline = false;
  @Input() includeResumeButton = false;
  @Input() includeContactButtons = false;

  socials: SocialInfo[];

  SocialInfoType = SocialInfoType;

  ngOnInit(): void {
    this.socials = this.buildSocialInfo();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.socials = this.buildSocialInfo();
  }

  private buildSocialInfo(): SocialInfo[] {
    return this.addHttpPrefixes(this.candidate.socialInfo);
  }

  private addHttpPrefixes(socialInfos: SocialInfo[]) {
    return (
      !!socialInfos
        ? socialInfos.map((info) =>
          info.url?.startsWith(HTTP_PREFIX) || info.url?.startsWith(HTTPS_PREFIX)
            ? SocialInfo.setType(info)
            : {
              ...SocialInfo.setType(info),
              url: HTTPS_PREFIX + info.url,
            },
        )
        : []
    );
  }
}
